/** Fixed on-map display sizes for real-estate markers (by real_estate_id). */
export const REAL_ESTATE_FIXED_SIZES: Record<number, { width: number; height: number }> = {
  1: { width: 87, height: 99 },
  2: { width: 86, height: 82 },
  3: { width: 110, height: 103 },
  4: { width: 102, height: 107 },
  5: { width: 100, height: 96 },
  6: { width: 107, height: 107 },
  7: { width: 105.98, height: 116.82 },
  8: { width: 108.63, height: 120 },
  9: { width: 87.3, height: 85 },
  10: { width: 86, height: 86 },
  11: { width: 134.4, height: 151.2 },
  12: { width: 146.4, height: 165.6 },
  13: { width: 121, height: 98 },
  14: { width: 100, height: 98 },
  15: { width: 130, height: 166 },
  16: { width: 120, height: 101 },
  17: { width: 120, height: 122 },
  18: { width: 127, height: 114 },
  19: { width: 160, height: 171 },
  20: { width: 98, height: 100 },
  21: { width: 113, height: 118 },
  22: { width: 113, height: 114 },
  23: { width: 113, height: 114 },
  24: { width: 112, height: 120 },
  25: { width: 113, height: 88 },
  26: { width: 111, height: 109 },
  27: { width: 120, height: 154 },
  28: { width: 107, height: 115 },
  29: { width: 87, height: 109 },
  30: { width: 119, height: 128 },
  31: { width: 119, height: 128 },
  32: { width: 119, height: 130 },
  33: { width: 115, height: 122 },
  34: { width: 117, height: 127 },
  35: { width: 109, height: 111 },
};

export const PLOT_MARKER_SIZE = { width: 87.302, height: 110 };

export const STATIC_OBJECT_FIXED_SIZES: Record<string, { width: number; height: number }> = {
  cityhall: { width: 180, height: 169 },
  shop: { width: 130, height: 122 },
  hell_of_flame: { width: 130, height: 122 },
  // Decor objects use native texture sizes; not listed here
};
